// extracted by mini-css-extract-plugin
export default {"userAdminContainer":"UserAdmin_userAdminContainer__v2MGx","header":"UserAdmin_header__yW1uW"};